import classNames from 'classnames';
import {FC} from 'react';
import styles from './MeinDivider.module.css';

interface IProps {
    className?: string;
}

export const MeinDivider: FC<IProps> = ({className}) => {
    return <div className={classNames(styles.divider, className)} />;
};
